export default "__VITE_ASSET__c88412cb__"